import * as React from 'react';

import { MultiraceProgram } from '@/lib/apollo/types/gen/graphql';
import { dayjst } from '@/lib/dayjst';
import { CurrentMultiraceProgramMap } from '@/modelTypes';
import { LotteryType } from '@/pages/Top/types';

import ProgramList from './ProgramList';
import {
  CharilotoLogo,
  DateWrapper,
  DokantoLogo,
  EmptyMessage,
  StyledLink,
} from './style';

interface MultiraceListProps {
  multiracePrograms: MultiraceProgram[];
}

const MultiraceList: React.FC<MultiraceListProps> = React.memo(
  ({ multiracePrograms }) => {
    const filteredList = (type: LotteryType): CurrentMultiraceProgramMap => {
      const obj = {} as CurrentMultiraceProgramMap;
      multiracePrograms
        .filter(mp => mp.multiraceType.match(type))
        .forEach(mp => {
          if (!obj[mp.velodromeCode]) {
            obj[mp.velodromeCode] = [];
          }
          obj[mp.velodromeCode].push(mp);
        });
      return obj;
    };

    const itemExist = (type: LotteryType): boolean => {
      return Object.values(filteredList(type)).flat().length > 0;
    };

    return (
      <div>
        <DateWrapper>
          <time>{dayjst().format('YYYY年M月D日')}</time>
          <StyledLink to="/guide/voting?type=lottery">
            チャリロト・Dokanto!とは
          </StyledLink>
        </DateWrapper>
        {itemExist(LotteryType.Chariloto) && (
          <div>
            <CharilotoLogo />
            <ProgramList
              multiraceProgramList={filteredList(LotteryType.Chariloto)}
            />
          </div>
        )}
        {itemExist(LotteryType.Dokanto) && (
          <div>
            <DokantoLogo />
            <ProgramList
              multiraceProgramList={filteredList(LotteryType.Dokanto)}
            />
          </div>
        )}
        {!itemExist(LotteryType.Chariloto) &&
          !itemExist(LotteryType.Dokanto) && (
            <EmptyMessage>開催がありません</EmptyMessage>
          )}
      </div>
    );
  },
);

export default MultiraceList;
